import { createApp } from '@app/adapters/create-app'
import WorkflowReviewStatusScreen from './../sections/workflow-review-status-screen'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-review-status']").each(function () {
    const {
      reviewData,
      preparation,
      ledgerId,
      itemClass,
      itemId,
      shouldRenderContent,
      shouldRenderInline,
    } = this.dataset

    const { review, reviews } = JSON.parse(reviewData)

    createApp(WorkflowReviewStatusScreen, {
      review,
      reviews,
      preparation: preparation ? JSON.parse(preparation) : null,
      ledgerId: parseInt(ledgerId, 10),
      itemClass,
      itemId: parseInt(itemId, 10),
      shouldRenderContent: shouldRenderContent !== 'false',
      shouldRenderInline: shouldRenderInline === 'true',
    }).mount(this)
  })
})
